import update from 'immutability-helper'
import _ from 'lodash'
import {
    RELATION_LIST_FETCHED,
    RELATION_MODEL_LOADED,
    RELATION_MODEL_UPDATED_BY_FORM,
    RELATION_MODEL_UPDATED_ON_SERVER,
    RELATION_MODEL_ADDRESS_CREATED,
    RELATION_MODEL_ADDRESS_UPDATED,
    RELATION_MODEL_CONTACT_CREATED,
    RELATION_MODEL_CONTACT_UPDATED,
    RELATION_MODEL_PRICING_CREATED,
    RELATION_MODEL_PRICING_UPDATED,
    RELATION_MODEL_PRICING_DELETED,
    RELATION_MODEL_NOTE_DELETED,
    RELATION_MODEL_NOTE_CREATED,
    RELATION_MODEL_NOTE_UPDATED
} from '../actions/types'

export default function user(state = {
    list: {
        on_page: 1,
        per_page: 15,
        total_count: 0,
        data: []
    },
    model: {
        special_pricings: [],
        contacts: [],
        addresses: [],
        notes: []
    },
    pristine: {
        special_pricings: [],
        contacts: [],
        addresses: []
    },
    dirty: false
}, action = {}) {
    switch(action.type) {
        case RELATION_LIST_FETCHED:
            return update(state, {
                list: {$set:action.payload}
            });

        case RELATION_MODEL_LOADED:
            return update(state, {
                model: {$set: action.payload},
                pristine: {$set: action.payload},
                dirty: {$set: false}
            });

        case RELATION_MODEL_UPDATED_BY_FORM:
            const {field, value} = action.payload;
            const updatedModel = update(state.model, {
                [field]: {$set: value}
            });
            if (_.isEqual(updatedModel, state.pristine)) {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: false}
                });
            } else {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: true}
                });
            }

        case RELATION_MODEL_UPDATED_ON_SERVER:
            return update(state, {
                pristione: {$set: action.payload},
                dirty: {$set: false}
            });

        case RELATION_MODEL_ADDRESS_CREATED:
            return update(state, {
                model: {
                    addresses: {$push: [action.payload]}
                },
                pristine: {
                    addresses: {$push: [action.payload]}
                }
            });

        case RELATION_MODEL_ADDRESS_UPDATED:
            const updateAddressIndex = _.findIndex(state.model.addresses, i => {
                return parseInt(i.id) === parseInt(action.payload.id);
            });
            if (updateAddressIndex > -1) {
                return update(state, {
                    model: {
                        addresses: {
                            [updateAddressIndex]: {$set: action.payload}
                        }
                    },
                    pristine: {
                        addresses: {
                            [updateAddressIndex]: {$set: action.payload}
                        }
                    }
                });
            }
            return state;

        case RELATION_MODEL_CONTACT_CREATED:
            return update(state, {
                model: {
                    contacts: {$push: [action.payload]}
                },
                pristine: {
                    contacts: {$push: [action.payload]}
                }
            });

        case RELATION_MODEL_CONTACT_UPDATED:
            const updateContactIndex = _.findIndex(state.model.contacts, i => {
                return parseInt(i.id) === parseInt(action.payload.id);
            });
            if (updateContactIndex > -1) {
                return update(state, {
                    model: {
                        contacts: {
                            [updateContactIndex]: {$set: action.payload}
                        }
                    },
                    pristine: {
                        contacts: {
                            [updateContactIndex]: {$set: action.payload}
                        }
                    }
                });
            }
            return state;

        case RELATION_MODEL_PRICING_CREATED:
            const createPricingIndex = _.findIndex(state.model.special_pricings, i => {
                return parseInt(i.id) === parseInt(action.payload.id);
            });
            if (createPricingIndex > -1) {
                return update(state, {
                    model: {
                        special_pricings: {
                            [updatePricingIndex]: {$set: action.payload}
                        }
                    },
                    pristine: {
                        special_pricings: {
                            [updatePricingIndex]: {$set: action.payload}
                        }
                    }
                });
            } else {
                return update(state, {
                    model: {
                        special_pricings: {$push: [action.payload]}
                    },
                    pristine: {
                        special_pricings: {$push: [action.payload]}
                    }
                });
            }

        case RELATION_MODEL_PRICING_UPDATED:
            const updatePricingIndex = _.findIndex(state.model.special_pricings, i => {
                return parseInt(i.id) === parseInt(action.payload.id);
            });
            if (updatePricingIndex > -1) {
                return update(state, {
                    model: {
                        special_pricings: {
                            [updatePricingIndex]: {$set: action.payload}
                        }
                    },
                    pristine: {
                        special_pricings: {
                            [updatePricingIndex]: {$set: action.payload}
                        }
                    }
                });
            }
            return state;

        case RELATION_MODEL_PRICING_DELETED:
            const pricingAfterDelete = state.model.special_pricings.filter(item => {
                return parseInt(item.id) !== parseInt(action.payload);
            });

            return update(state, {
                model: {
                    special_pricings: {$set: pricingAfterDelete}
                },
                pristine: {
                    special_pricings: {$set: pricingAfterDelete}
                }
            })

        case RELATION_MODEL_NOTE_DELETED:
            const noteIndex = _.findIndex(state.model.notes, n => {
                return n.id === action.payload
            })
            if (noteIndex > -1) {
                return update(state, {
                    model: {
                        notes: {$splice: [[noteIndex, 1]]}
                    }
                })
            }
            return state

        case RELATION_MODEL_NOTE_CREATED:
            return update(state, {
                model: {
                    notes: {$push: [action.payload]}
                }
            })

        case RELATION_MODEL_NOTE_UPDATED:
            const noteIndexUpdate = _.findIndex(state.model.notes, n => {
                return n.id === action.payload.id
            })
            if (noteIndexUpdate > -1) {
                return update(state, {
                    model: {
                        notes: {[noteIndexUpdate]: {
                                $set: action.payload
                            }}
                    }
                })
            }
            return state

        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/stores/relation.js